import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { IOAuth2ConfigurationSimpleDto, ISamlConfigurationSimpleDto } from "../shared/interfaces";
import { Observable } from "rxjs";
import { ISearchParams } from "../shared/interfaces/general.interface";

@Injectable({
  providedIn: "root"
})
export class FederatedAuthenticationService{
  private samlBaseUrl = environment.saml_api_url
  private oauth2BaseUrl = environment.oauth2_api_url
  constructor(
    private http: HttpClient
  ){

  }

  public getSamlOrganisationRegistrationId(organisationId: string): Observable<ISamlConfigurationSimpleDto[]> {
    return this.http.get<ISamlConfigurationSimpleDto[]>(`${this.samlBaseUrl}/public/api/v1/saml/configurations/${organisationId}`)
  }
  public continueSamlConfiguration(registrationId: string, returnUrl: string) {
    const samlRequestUrl = `${this.samlBaseUrl}/saml2/authentcate/${registrationId}?returnUrl=${returnUrl}`
    window.location.href = samlRequestUrl
  }
  public getOAuth2OrganisationRegistrationId(params: ISearchParams): Observable<IOAuth2ConfigurationSimpleDto[]> {
    let queryParams: HttpParams = new HttpParams()
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        queryParams = queryParams.append(key, params[key])
      }
    })
    return this.http.get<IOAuth2ConfigurationSimpleDto[]>(`${this.oauth2BaseUrl}/public/api/v1/providers`, { params: queryParams })
  }

  public continueOAuth2Configuration(registrationId: string, returnUrl: string) {
    const request = `${this.oauth2BaseUrl}/oath2/authentcate/${registrationId}?returnUrl=${returnUrl}`
    window.location.href = request
  }
}
